import { useEffect, useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

import { CSS_VARIABLES } from "enums/cssVariables";

import { SpinnerProps } from "./types";
import VisuallyHidden from "./VisuallyHidden";

// Delay before the label is added to the status region: screen readers only
// announce the changes of a region that is already in the page (RGAA 7.5)
const LABEL_DELAY_MS = 100;

const Spinner = ({ label }: SpinnerProps) => {
    const { t } = useTranslation();
    const [isLabelShown, setIsLabelShown] = useState(false);

    useEffect(() => {
        const timeoutId = window.setTimeout(() => {
            setIsLabelShown(true);
        }, LABEL_DELAY_MS);

        return () => {
            window.clearTimeout(timeoutId);
        };
    }, []);

    const statusLabel = isLabelShown ? (label ?? t("loadingInProgress")) : null;

    return (
        <div role="status">
            <SpinnerComponent />
            <VisuallyHidden>{statusLabel}</VisuallyHidden>
        </div>
    );
};

const SpinnerComponent = styled.div`
    border: 10px solid #f3f3f3;
    border-top: 10px solid var(${CSS_VARIABLES.PRIMARY_BUTTON_BACKGROUND_COLOR});
    border-radius: 50%;
    width: 55px;
    height: 55px;
    margin: auto;
    animation: spin 1s linear infinite;
    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
`;

export default Spinner;
